<template lang="pug">
  y-dialog(fill-height fluid v-model="showModal" scrollable transition="fade-transition" persistent max-width="600px" :fullscreen="$vuetify.breakpoint.xsOnly")
    v-card
      v-card-title.px-5(:style="`background-color: ${$vuetify.theme.themes[$theme].basic600T16}`")
        v-row(no-gutters align="center")
          v-col.shrink
            v-btn.ml-n3(text icon @click="showModal = !showModal")
              v-icon(color="basic800" :size="24") mdi-close
          v-col.ml-3
            p.mb-0.h6.basic800--text {{ $t('edit_order') }}

      v-card-text.px-0.pb-0.pt-4
        v-container.pa-0
          v-layout.my-6(v-if="fetchStat")
            v-row.fill-height.ma-0(align='center' justify='center')
              v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
          div(v-else)
            v-row.fill-height.ma-0(align='center' justify='center' v-if="products.length == 0")
              div.mx-auto.text-center
                v-img.mx-auto(:src="require('@/assets/images/icon_empty.png')" style="width:80px; height:80px" contain)
                p.caption {{ $t('form_no_longer_available') }}
                v-btn.primary.mb-2(small @click="showAllProducts") {{ $t('open_all_products') }}
            div(v-else)
              template(v-for="(product, index) in products")
                v-card.pa-1(flat)
                  v-row.mt-1(no-gutters)
                    v-col.shrink
                      v-card.px-1(flat)
                        v-img(:src="product.image ? product.image.file : require('@/assets/image_placeholder.png')" height="80px" width="80px")
                    v-col.px-1
                      div.p1.basic800--text.mb-1 {{ product.name }}
                      div.mb-1(v-if="product.has_bundles")
                        div(v-for="(bundle, idx) in product.bundles" :key="'bundle-' + idx")
                          div.c1.basic600--text {{ idx + 1 }}. {{ bundle.name }}
                      div.c1.basic600--text.product-description.mb-1(v-else v-html="product.description")
                      div.c2.basic600--text {{ product.price | displayPrice }}
                  div.d-flex.px-1
                    div.d-flex.align-center.s1.basic800--text
                      div {{ $t('discount') }}:
                      div.d-flex(@click="product.openEditDiscount = true")
                        div.ml-1 {{ product.discount | displayPrice }}
                        v-icon.ml-1(small) mdi-pencil
                    v-spacer
                    div.d-flex.align-center
                      v-btn(icon @click="product.has_variants ? onVariants(product) : product.has_addons ? onAddons(product) : product.quantity--" :disabled="product.quantity < 1")
                        v-icon(color="teal") mdi-minus-circle
                      div.colbox.text-center
                        span.subtitle-2 {{ product.quantity }}
                      v-btn(icon @click="product.has_variants ? onVariants(product) : product.has_addons ? onAddons(product) : product.quantity++" :disabled="checkStock(product)")
                        v-icon(color="teal") mdi-plus-circle
                  y-dialog(v-model='product.openEditDiscount', max-width='320' persistent)
                    v-card
                      v-card-title.pb-0.px-4.h6.basic800--text {{ $t('update_discount') }}
                      v-divider.basic300
                      v-card-text.px-4.pt-4
                        p.mb-2.label.basic600--text.text-uppercase {{ $t('price.label') }}
                        v-text-field(v-model='product.discountValue' :placeholder="$t('price.placeholder')" background-color="basic200" height="40" outlined dense type="number" :prefix="$currency.symbol")
                      v-card-actions
                        v-spacer
                        v-btn(color='white', text @click='product.openEditDiscount = false')
                          .button-Aa-small.primary400--text {{ $t('cancel') }}
                        v-btn.mr-2(color='textColorAccent' depressed height=32 @click='updatePrice(index)' dark)
                          .button-AA-small.basic100--text {{ $t('update') }}
                          
                v-divider.basic300
              div.mt-4(align="center")
                v-btn.button-Aa-medium.custom-transform-class.text-none.px-2(color="textColorAccent" text @click="showAllProducts" small) {{ $t('open_all_products') }}

      v-card-actions
        v-spacer
        v-btn(color='white', text @click='showModal = false')
          .button-Aa-small.primary400--text {{ $t('cancel') }}
        v-btn.mr-2(color='textColorAccent' depressed height=32 :loading="isUpdating" @click='clickUpdate' dark)
          .button-AA-small.basic100--text {{ $t('update_order') }}

      .modals
        .productOptions(style="max-width:500px")
          variants(v-if="openVariants" :open.sync="openVariants" :product.sync="vProduct" :inventory.sync="vInventory" language="en" @finalVariants="getVariants($event)")
        .productAddons(style="max-width:500px")
          addons(v-if="openAddons" :open.sync="openAddons" :product="aProduct" :inventory.sync="aInventory" language="en" @finalProdAddon="getProdAddon($event)")

</template>

<script>
import { mapActions } from 'vuex'
import Variants from '@/components/forms/Variants.vue'
import Addons from '@/components/forms/Addons.vue'
import ShowMoreText from '@/components/ShowMoreText'

export default {
  name: 'EditOrderDialog',
  props: ['open', 'parentLead'],
  components: { Variants, Addons, ShowMoreText },
  data: () => ({
    isFetching: [],
    // fetchStat: true,
    products: [],
    isUpdating: false,
    openVariants: false,
    openAddons: false,
    vProduct: null,
    vOption: null,
    vVariants: null,
    vInventory: null,
    aProduct: null,
    aInventory: null
  }),
  computed: {
    lead: {
      get() {
        return this.parentLead
      },
      set(newValue) {
        this.$emit('update:parentLead', newValue)
      }
    },
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
    fetchStat () {
      if (this.isFetching.length > 0) {
        return true
      } else {
        return false
      }
    }
  },
  mounted () {
    this.fetchProducts()
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    updatePrice (index) {
      const discountTotal = (parseFloat(this.products[index].discountValue || 0)).toFixed(this.$currency.exponent).replace('.', '')
      if (discountTotal > this.products[index].price) {
        this.showMessage(['error', this.$t('error_message.discount_price_not_bigger')])
        return
      }
      this.products[index].discount = discountTotal
      this.products[index].openEditDiscount = false
    },
    fetchProducts() {
      let productId = []
      let product_restr = []
      const distinct = (value, index, self) => {
        return self.indexOf(value) === index
      }
      this.lead.products.forEach(o => {
        o.product.variant_for ? productId.push(o.product.variant_for) : productId.push(o.product.id)
        if (o.product.variant_for) {
          product_restr.push({
            id: o.product.id,
            edit_id: o.id,
            name: o.name,
            price: o.product.price,
            discount: o.discount,
            discountValue: o.discount/this.$currency.multiplier,
            quantity: o.quantity,
            variant_for: o.product.variant_for,
            addons: []
          })
        } else if (o.addons.length > 0) {
          product_restr.push({
            id: o.product.id,
            edit_id: o.id,
            name: o.name,
            price: o.product.price,
            discount: o.discount,
            discountValue: o.discount/this.$currency.multiplier,
            quantity: o.quantity,
            variant_for: null,
            addons: o.addons.map(m => { return { 
              id: m.product.id,
              edit_id: m.id,
              name: m.name,
              price: m.product.price,
              quantity_per_set: m.quantity_per_set
            }})
          })
        } else if (o.bundles.length > 0) {
          product_restr.push({
            id: o.product.id,
            edit_id: o.id,
            name: o.name,
            price: o.product.price,
            discount: o.discount,
            discountValue: o.discount/this.$currency.multiplier,
            quantity: o.quantity,
            variant_for: null,
            bundles: o.bundles
          })
        } else {
          product_restr.push({
            id: o.product.id,
            edit_id: o.id,
            name: o.name,
            price: o.product.price,
            discount: o.discount,
            discountValue: o.discount/this.$currency.multiplier,
            quantity: o.quantity,
            variant_for: null,
            addons: []
          })
        }
      })
      productId.filter(distinct).forEach((o) => {
        this.isFetching.push(true)
        this.$axios.get(`/products/${o}/?expand=variants,options`)
        .then(resp => {
          if (resp.data.has_variants) {
            // console.log('variants', resp.data,)
            let variants = product_restr.filter(f => f.variant_for === o).map(m => { return { ...m, selectedOptions: resp.data.variants.find(f => f.product.id === m.id).specs.map(p => { return { id: resp.data.options.find(i => i.specs.map(a => a.id).includes(p)).id, selected: p } }) } })
            const item = {
              id: resp.data.id,
              edit_id: null,
              name: resp.data.name,
              description: resp.data.description,
              price: resp.data.price,
              image: resp.data.image,
              discount: variants[0].discount,
              discountValue: variants[0].discount/this.$currency.multiplier,
              quantity: variants.map(m => { return m.quantity }).reduce((total, num) => { return total + num }, 0),
              variants: resp.data.variants,
              variant_products: variants,
              options: resp.data.options,
              has_variants: true,
              has_addons: false,
              has_bundles: false,
              openEditDiscount: false,
              inventory_enabled: resp.data.inventory_enabled,
              inventory_qty: resp.data.inventory_qty
            }
            this.products.push(item)
          } else if (resp.data.has_addons) {
            // console.log('addons', resp.data,)
            let productWithAddons = product_restr.filter(f => f.id === o)
            const item = {
              id: resp.data.id,
              edit_id: null,
              name: resp.data.name,
              description: resp.data.description,
              price: resp.data.price,
              image: resp.data.image,
              discount: productWithAddons[0].discount,
              discountValue: productWithAddons[0].discount/this.$currency.multiplier,
              quantity: productWithAddons.map(m => { return m.quantity }).reduce((total, num) => { return total + num }, 0),
              addon_products: productWithAddons,
              has_variants: false,
              has_addons: true,
              has_bundles: false,
              openEditDiscount: false,
              inventory_enabled: resp.data.inventory_enabled,
              inventory_qty: resp.data.inventory_qty
            }
            this.products.push(item)
          } else if (resp.data.has_bundles) {
            // console.log('pure', resp.data,)
            let productWithBundles = product_restr.filter(f => f.id === o)[0]
            const item = {
              id: productWithBundles.id,
              edit_id: productWithBundles.edit_id,
              name: productWithBundles.name,
              description: resp.data.description,
              price: productWithBundles.price,
              image: resp.data.image,
              discount: productWithBundles.discount,
              discountValue: productWithBundles.discountValue,
              quantity: productWithBundles.quantity,
              bundles: productWithBundles.bundles,
              has_variants: false,
              has_addons: false,
              has_bundles: true,
              openEditDiscount: false,
              inventory_enabled: resp.data.inventory_enabled,
              inventory_qty: resp.data.inventory_qty
            }
            this.products.push(item)
          } else {
            // console.log('pure', resp.data,)
            let prodonly = product_restr.filter(f => f.id === o)[0]
            const item = {
              id: prodonly.id,
              edit_id: prodonly.edit_id,
              name: prodonly.name,
              description: resp.data.description,
              price: prodonly.price,
              image: resp.data.image,
              discount: prodonly.discount,
              discountValue: prodonly.discountValue,
              quantity: prodonly.quantity,
              has_variants: false,
              has_addons: false,
              has_bundles: false,
              openEditDiscount: false,
              inventory_enabled: resp.data.inventory_enabled,
              inventory_qty: resp.data.inventory_qty
            }
            this.products.push(item)
          }
        })
        .catch(() => {})
        .finally(() => {
          this.isFetching.pop()
        })
      })
    },
    showAllProducts() {
      window.open(`/invoices/${this.lead.pid}/catalogs`, '_blank')
    },
    checkStock (product) {
      if (product.has_bundles) {
        if (product.quantity >= 1) {
          return true
        }
      } else if (!product.has_variants && !product.has_addons) {
        if (product.inventory_enabled && product.quantity >= product.inventory_qty) {
          return true
        }
      }
      return false
    },
    clickUpdate() {
      let selectedProducts = []
      this.products.forEach(product => {
        if (product.has_variants) {
          product.variant_products.forEach(o => {
            const item = {
              id: o.edit_id || null,
              product: o.id,
              quantity: o.quantity,
              discount: product.discount,
            }
            selectedProducts.push(item)
          })
        } else if (product.has_addons) {
          product.addon_products.forEach(o => {
            const item = {
              id: o.edit_id,
              product: o.id,
              quantity: o.quantity,
              discount: product.discount,
              addons: o.addons.map(m => { return {
                id: m.edit_id || null,
                product: m.id,
                quantity_per_set: m.quantity_per_set || 0
              }}).filter(f => f.id || (!f.id && f.quantity_per_set > 0))
            }
            selectedProducts.push(item)
          })
        } else {
          const item = {
            id: product.edit_id,
            product: product.id,
            quantity: product.quantity,
            discount: product.discount,
          }
          selectedProducts.push(item)
        }
      })
      if (selectedProducts.length == 0) {
        this.showMessage(['error', this.$t('error_message.no_product_selected')])
        return
      }
      selectedProducts = selectedProducts.filter(f => f.id || (!f.id && f.quantity > 0))
      this.isUpdating = true
      const params = {
        products: selectedProducts,
      }
      this.axios.patch(`/leads/${this.lead.pid}/`, params)
        .then(resp => {
          // console.log(resp)
          this.lead = resp.data
          this.showModal = false
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isUpdating = false
        })
    },
    onVariants (val) {
      this.vProduct = { ...val }
      this.vInventory = { inv_enable: val.inventory_enabled, inv_qty: val.inventory_qty }
      this.openVariants = true
    },
    onAddons (val) {
      this.aProduct = { ...val }
      this.aInventory = { inv_enable: val.inventory_enabled, inv_qty: val.inventory_qty }
      this.openAddons = true
    },
    getVariants (val) {
      const a = this.products.filter(f => f.id === val.parent_id)[0]
      const b = val.variant_products
      if (b.length > 0) {
        a.variant_products = [...b]
        a.quantity = b.map(m => m.quantity).reduce((total, num) => { return total + num }, 0)
      } else {
        a.variant_products = null
        a.quantity = 0
      }
      this.vProduct = {}
    },
    getProdAddon (val) {
      let a = this.products.filter(f => f.id === val.parent_id)[0]
      let b = val.addon_products
      if (b.length > 0) {
        a.addon_products = [...b]
        a.quantity = b.map(m => { return m.quantity }).reduce((total, num) => { return total + num }, 0)
      } else {
        a.addon_products = null,
        a.quantity = 0
      }
      this.aProduct = {}
    },
  }
}
</script>

<style scoped>
.colbox {
  border: 2px solid #009688;
  border-radius: 5px;
  height: 26px;
  width: 56px;
}
.product-description {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical; 
  overflow: hidden;
}
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
</style>

<i18n>
{
  "en": {
    "update_order": "Update Order",
    "price": {
      "label": "Price",
      "placeholder": "0"
    },
    "open_all_products": "Open all products",
    "update_discount": "Update discount",
    "form_no_longer_available": "This form is no longer available"
  },
  "id": {
    "update_order": "Perbarui Order",
    "price": {
      "label": "Harga",
      "placeholder": "0"
    },
    "open_all_products": "Lihat semua produk",
    "update_discount": "Perbarui diskon",
    "form_no_longer_available": "Form ini tidak lagi tersedia"
  }
  
}
</i18n>